<template>
  <ul>
    <li style="margin-bottom: 12px;">
      <el-tag
        :key="item.key"
        v-for="item in filters"
        closable
        :disable-transitions="false"
        @close="handleClose(item)"
        style="margin-right: 12px;"
      >{{ item.label }}</el-tag>
    </li>
    <li v-for="item in dataSources" :key="item.id" class="list-root">
      <div class="clearfix" style="cursor: pointer;" @click="toNext(item)">
        <img :src="kerunHeader" style="width: 50px;height: 50px;border-radius: 50px;float: left;" />
        <div
          style="line-height: 25px;font-size: 16px;color: #333;margin-left: 72px;"
        >南京科润</div>
        <!-- {{ item.createuser }} -->
        <div
          style="line-height: 25px;font-size: 12px;color: #999;margin-left: 72px;"
        >发布时间：{{ item.release_time }}</div>
      </div>
      <div class="jf-show" v-if="item.class === '2' || (item.integral && item.integral > 0)">{{ item.integral ? item.integral : 0 }}积分</div>
      <div class="item-title" @click="toNext(item)">
        {{ item.title ? item.title : '' }}
        <label class="item-staus" v-if="item && item.isoriginal && String(item.isoriginal) !== '0'">原创</label>
      </div>
      <div class="item-content-root" @click="toNext(item)">
        <div style="margin-right: 160px;">
          <div style="font-size: 14px;color: #666">{{ item.abstract ? item.abstract: '暂无简介' }}</div>
        </div>
        <img :src="item.article_img" />
      </div>
      <div
        style="position:relative;margin-top: 12px;"
        v-if="item.labelItemList && item.labelItemList.length > 0"
      >
        <template v-for="lilitem in item.labelItemList">
          <span
            :key="lilitem.id"
            class="item-label"
            :style="{backgroundColor: lilitem.color,borderColor: lilitem.color}"
            @click="toFilter(lilitem)"
          >{{ lilitem.text }}</span>
        </template>

        <el-button type="text" disabled>{{ item.keywords1 }}</el-button>
        <el-button type="text" disabled>{{ item.keywords2 }}</el-button>
        <el-button type="text" disabled>{{ item.keywords3 }}</el-button>

        <div class="item-content-header" style="float: right;color: #666;margin-left: 10px;">
          <i
            class="iconfont icon-heart"
            style="vertical-align: middle;margin-left: 12px;margin-right: 6px;"
          />
          {{ item.likenum ? item.likenum: 0 }}
          <i
            class="iconfont icon-message"
            style="vertical-align: middle;margin-left: 12px;margin-right: 6px;"
          />
          {{ item.commentsnum ?item.commentsnum :0 }}
        </div>
      </div>
    </li>
    <li style="margin: 12px 12px;">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentIndex"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
      ></el-pagination>
    </li>
  </ul>
</template>
<script>
import xyAPI from '@/api/xyAPI'
import xy_config from '@/config/xy_config'
import loadData from '@/https/loadData'
import kerunHeader from '@/assets/imgs/kerun-header.png'
import moment from 'moment'
export default {
  name: 'ArticleList',
  data () {
    return {
      labelConfigs: [],
      dataSources: [],
      pageIndex: 0,
      pageSize: 8,
      totalNum: 0,
      sortField: 'createtime',
      sortOrder: 'desc',
      startLoadding: false,
      kerunHeader: kerunHeader,
      filters: []
    }
  },
  computed: {
    currentIndex () {
      return this.pageIndex + 1
    }
  },
  mounted () {
    const fl = [...this.filters]
    const classType = this.$route.query.classType
    const classStr = this.$route.query.classStr
    const classKey = this.$route.query.classKey
    const keyStr = this.$route.query.keyStr
    if (classType) {
      fl.push({
        key: 'class',
        value: classType,
        label: String(classType) === '1' ? '环球视野' : '润智学堂'
      })
    }
    if (classKey && classStr) {
      fl.push({
        key: 'label',
        value: classKey,
        label: classStr
      })
    }
    if (keyStr) {
      fl.push({
        key: 'title',
        value: keyStr,
        label: keyStr
      })
    }
    this.filters = fl
    this.getLabelConfig()
  },
  methods: {
    addKey (Str) {
      // 修改filter
      let fl = [...this.filters]
      fl = fl.filter(fItem => {
        if ('title' === fItem.key) {
          return false
        } else {
          return true
        }
      })
      fl.push({
        key: 'title',
        value: Str,
        label: Str
      })
      this.filters = fl
      this.refreshData()
    },
    handleCurrentChange (val) {
      if (val > 0) {
        this.pageIndex = val - 1
        this.getData()
      }
    },
    handleClose (item) {
      let _f = [...this.filters]
      _f = _f.filter(fItem => {
        if (fItem.key === item.key) {
          return false
        } else {
          return true
        }
      })
      this.filters = _f
      this.refreshData()
    },
    toFilter (item) {
      // 修改filter
      let fl = [...this.filters]
      fl = fl.filter(fItem => {
        if ('label' === fItem.key) {
          return false
        } else {
          return true
        }
      })
      fl.push({
        key: 'label',
        value: item.code,
        label: item.text
      })
      this.filters = fl
      this.refreshData()
    },
    toDetail (item) {
      this.$router.push({ name: 'ArticleDetail', query: { id: item.id } })
    },
    refreshData () {
      this.pageIndex = 0
      this.getData()
    },
    async toNext (item) {
      const _that = this
      if ((!item.integral) && (item.class !== '2')) {
        // 直接跳转下一个页面
        _that.toDetail(item)
      } else {
        // 检查是否登录
        const tokenCookie = _that.$cookie.get(xy_config.cookieToken)
        if (tokenCookie) {
          if(!item.integral) {
            _that.toDetail(item)
          }
          // 检查是否已经购买
          const res = await loadData(xyAPI.queryUserIsBuyArticle, { articleid: item.id })
          if (res && String(res.code) === '0') {
            // 如果已经购买跳转详情页面
            _that.toDetail(item)
          } else {
            _that.$alert((res && res.msg ? res.msg : '文章未兑换，需要积分兑换之后才能查看'), '提示', {
              confirmButtonText: '去购买',
              showCancelButton: true,
              callback: action => {
                if (action === 'confirm') {
                  // 如果没有购买弹出购买提示
                  _that.$alert('确认消费' + item.integral + '积分查看文章?', '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: true,
                    callback: async action => {
                      if (action === 'confirm') {
                        // 调用兑换接口
                        const res = await loadData(xyAPI.userBuyArticle, { articleid: item.id })
                        if (res && String(res.code) === '0') {
                          _that.$message({
                            message: '操作成功',
                            onClose: () => {
                              _that.toDetail(item)
                            }
                          })
                        } else {
                          _that.$message(res && res.msg ? res.msg : '操作失败')
                        }
                      }
                    }
                  })
                }
              }
            })
          }
        } else {
          // 没有登录跳转登录
          _that.$alert('积分兑换文章需要登录之后才能查看', '提示', {
            confirmButtonText: '去登录',
            showCancelButton: true,
            callback: action => {
              if (action === 'confirm') {
                // 跳转登录
                _that.$message({
                  message: '登录后操作',
                  duration: 1000,
                  onClose: () => {

                    const toURL = window.location.origin + window.location.pathname + '#ArticleDetail?id=' + item.id
                    window.location.href = '../login/login.html?to=' + escape(toURL)
                    // window.location.href = '../login/login.html?to=' + escape(window.location.href)
                  }
                })
              }
            }
          })
        }
      }
    },
    async getLabelConfig () {
      const _that = this
      try {
        const res = await loadData(xyAPI.queryLabelConfig)
        if (res && String(res.code) === '0') {
          _that.labelConfigs = res.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.getData()
        window.addEventListener('scroll', this.scrollBottom)
      }
    },
    async getData () {
      const _that = this
      if (_that.startLoadding) {
        return
      }
      try {
        _that.startLoadding = true
        const lParam = {
          state: '2',
          '@title': 'like_anywhere'
        }
        if (this.filters) {
          this.filters.map(fItem => {
            lParam[fItem.key] = fItem.value
          })
        }
        const res = await loadData(xyAPI.getArticlePager, { pageIndex: _that.pageIndex, pageSize: _that.pageSize, '@params': JSON.stringify(lParam), sortField: _that.sortField, sortOrder: _that.sortOrder })
        if (res && res.data) {
          _that.totalNum = res.total
          const mData = [...res.data]
          if (this.labelConfigs && this.labelConfigs.length > 0) {
            mData.map(item => {
              if (item.release_time) {
                item['release_time'] = moment(item.release_time).format('YYYY-MM-DD')
              }
              const mLableItemList = []
              if (item.label) {
                const labels = item.label.split(',')
                labels.map(lstr => {
                  this.labelConfigs.some(lcItem => {
                    if (lcItem.code === lstr) {
                      mLableItemList.push(lcItem)
                      return true
                    }
                  })
                })
              }
              item['labelItemList'] = [...mLableItemList]
            })
          }
          _that.dataSources = mData
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.startLoadding = false
      }
    },
  }
}
</script>
<style lang="less" scoped>
.list-root {
  border: 1px solid #e0e0e0;
  background: #fff;
  padding: 25px;
  border-radius: 5px;
  position: relative;
  margin-bottom: 12px;
  .jf-show {
    cursor: pointer;
    padding: 12px 12px;
    display: inline-block;
    background: #f00;
    color: #fff;
    position: absolute;
    top: 0;
    right: 24px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    -webkit-box-shadow: 2px 2px 3px #aaaaaa;
    box-shadow: 2px 2px 3px #aaaaaa;
  }
  .item-title {
    cursor: pointer;
    font-size: 18px;
    color: #111;
    line-height: 28px;
    margin-bottom: 6px;
    margin-top: 6px;
    .item-staus {
      padding: 0px 6px;
      line-height: 18px;
      font-size: 14px;
      background: #f00;
      color: #fff;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 4px;
      border-top-left-radius: 4px;
      border-top-right-radius: 8px;
      margin-left: 12px;
    }
  }
  .item-content-root {
    cursor: pointer;
    position: relative;
    min-height: 70px;
    .item-content-header {
      font-size: 12px;
      color: #999;
      line-height: 16px;
      margin-bottom: 6px;
    }
    img {
      width: 140px;
      height: 100px;
      right: 10px;
      top: -28px;
      position: absolute;
    }
  }
  .item-label {
    cursor: pointer;
    display: inline-block;
    height: 24px;
    padding: 0 10px;
    line-height: 22px;
    font-size: 12px;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    white-space: nowrap;
    color: #409eff;
    background-color: #409eff;
    border-color: #409eff;
    color: #fff;
    margin-right: 12px;
  }
}
</style>